const COMMON = {
  user: { status: { _eq: "active" } },
};

export const EMPLOYEE_FILTERS_FORM = {
  all: {
    ...COMMON,
  },
  client: {
    type: "client",
  },
  jobs_coordinating: {
    user: {
      ...COMMON.user,
      role: {
        is_job_coordinator: {
          _eq: true,
        },
      },
    },
  },
  projects_coordinating: {
    user: {
      ...COMMON.user,
      role: {
        is_project_coordinator: {
          _eq: true,
        },
      },
    },
  },
  milestones_coordinating: {
    user: {
      ...COMMON.user,
      role: {
        is_milestone_coordinator: {
          _eq: true,
        },
      },
    },
  },
  account_manager: {
    user: {
      ...COMMON.user,
      role: {
        is_account_manager: {
          _eq: true,
        },
      },
    },
  },
  sales_coordinating: {
    user: {
      ...COMMON.user,
      role: {
        is_sales_coordinator: {
          _eq: true,
        },
      },
    },
  },
  department_head: {
    user: {
      ...COMMON.user,
      role: {
        is_department_head: {
          _eq: true,
        },
      },
    },
  },
  department_coordinating: {
    user: {
      ...COMMON.user,
      role: {
        is_department_coordinator: {
          _eq: true,
        }
      }
    }
  },
  plan: {
    ...COMMON,
    _or: [
      { reports_to: { user: { _eq: "$CURRENT_USER" } } },
      { user: { _eq: "$CURRENT_USER" } },
    ],
  },
};

export const EMPLOYEE_FILTERS = {
  all: {
  },
  client: {
    type: "client",
  },
  jobs_coordinating: {
    user: {
      role: {
        is_job_coordinator: {
          _eq: true,
        },
      },
    },
  },
  projects_coordinating: {
    user: {
      role: {
        is_project_coordinator: {
          _eq: true,
        },
      },
    },
  },
  milestones_coordinating: {
    user: {
      role: {
        is_milestone_coordinator: {
          _eq: true,
        },
      },
    },
  },
  account_manager: {
    user: {
      role: {
        is_account_manager: {
          _eq: true,
        },
      },
    },
  },
  sales_coordinating: {
    user: {
      role: {
        is_sales_coordinator: {
          _eq: true,
        },
      },
    },
  },
  department_head: {
    user: {
      role: {
        is_department_head: {
          _eq: true,
        },
      },
    },
  },
  department_coordinating: {
    user: {
      role: {
        is_department_coordinator: {
          _eq: true,
        }
      }
    }
  },
  plan: {
    _or: [
      { reports_to: { user: { _eq: "$CURRENT_USER" } } },
      { user: { _eq: "$CURRENT_USER" } },
    ],
  },
};
